import { toaster } from '../../ui/toaster';

export const ACCEPTED_EXTS = '.png,.jpg,.jpeg,.pdf';
export const MAX_BYTES = 25 * 1024 * 1024;

export function validate(file: File | undefined): file is File {
  if (!file) return false;
  if (file.size > MAX_BYTES) {
    toaster.create({
      title: 'File too large',
      description: 'Blueprint must be 25MB or smaller.',
      type: 'error',
      duration: 4000,
    });
    return false;
  }
  return true;
}
